// project imports

// action - state management
import * as actionTypes from 'store/actions/auth';

export const initialState = {
    user: {},
    profile: {}
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTH_INIT:
            return {
                profile: {},
                user: {}
            };
        case actionTypes.SET_PROFILE:
            return {
                ...state,
                profile: action.data || {}
            };

        case actionTypes.SET_USER:
            return {
                ...state,
                profile: action.data || {}
            };

        default:
            return state;
    }
};

export default authReducer;
